export default __webpack_public_path__ + "static/media/pot1.0f570ce5.gif";